
import * as types from './materialActionTypes.js';

export const getMaterialRequestAction = (payload) => ({
  type: types.GET_MATERIAL_REQUEST,
  payload,
});

export const getMaterialDataAction = (payload) => ({
  type: types.GET_MATERIAL_DATA,
  payload,
});

export const getMaterialErrorAction = (payload) => ({
  type: types.GET_MATERIAL_ERROR,
  payload,
});

export const createMaterialRequestAction = (payload) => ({
  type: types.CREATE_MATERIAL_REQUEST,
  payload,
});

export const createMaterialDataAction = (payload) => ({
  type: types.CREATE_MATERIAL_DATA,
  payload,
});

export const createMaterialErrorAction = (payload) => ({
  type: types.CREATE_MATERIAL_ERROR,
  payload,
});

export const updateMaterialRequestAction = (payload) => ({
  type: types.UPDATE_MATERIAL_REQUEST,
  payload,
});

export const updateMaterialDataAction = (payload) => ({
  type: types.UPDATE_MATERIAL_DATA,
  payload,
});

export const updateMaterialErrorAction = (payload) => ({
  type: types.UPDATE_MATERIAL_ERROR,
  payload,
});

export const deleteMaterialRequestAction = (payload) => ({
  type: types.DELETE_MATERIAL_REQUEST,
  payload,
});

export const deleteMaterialDataAction = (payload) => ({
  type: types.DELETE_MATERIAL_DATA,
  payload,
});

export const deleteMaterialErrorAction = (payload) => ({
  type: types.DELETE_MATERIAL_ERROR,
  payload,
});